import styledBreakpoint from './styledbreakpoint';
/** content max width size */
export const contentMaxSize = 1120;
export const mediaQuerySizes = {
    xsmall: 0,
    belowSmall: 767,
    small: 768,
    belowMedium: 991,
    medium: 992,
    belowLarge: 1199,
    large: 1200,
    xlarge: 1450,
    giant: 1600,
};
/**
 * Usage:
 * ```
 * // Same as up()
 * ${media.xsmall`
 *  display:none;
 * `}
 * // min-width 601
 * ${media.up('small')`
 *   display: none;
 * `}
 *
 * // max-width 601
 * ${media.down('small')`
 *   display: none;
 * `}
 *
 * // range 0 - 992
 * ${media.only('xsmall','medium')`
 *   display: none;
 * `}
 * ```
 *
 * [styled-components-breakpoints media query docs]{@link https://github.com/wearehumblebee/styled-components-breakpoint}
 */
export const mediaQueries = styledBreakpoint(mediaQuerySizes);
export default mediaQueries;
//# sourceMappingURL=index.js.map